import { AcceptClientLegalese, AcceptUserLegalese } from '@Components/Legal';
import { useAppState } from '@Contexts/appContext';
import { type FC, type PropsWithChildren } from 'react';
import { useSession } from './SessionContext';

export const LegalDocumentAcceptanceGuard: FC<PropsWithChildren> = ({ children }) => {
    const { current } = useSession();
    const { profile, reload } = useAppState();

    if (!profile.client_legal_document_accepted) {
        return <AcceptClientLegalese clientId={current.clientId} refetchAuthorization={reload} />;
    }

    if (!profile.user_legal_document_accepted) {
        return <AcceptUserLegalese refetchProfile={reload} />;
    }

    return children;
};
